import axios from 'axios'
import Token from '../module/token'
import store from '@/store'
import YunLinked from 'yunlinked'
// import YunLinked from '../../../linked-js/src/index.js'

Token.en()
const http = axios.create({
  baseURL: process.env.VUE_APP_API_SUB_PATH,
})
http.interceptors.request.use((config) => {
  config.headers.common = {
    traceId: YunLinked.mainGetId(),
    deviceId: YunLinked.mainGetDeviceId(),
    // uaObj: JSON.stringify(YunLinked.getUa()) || '',
    isWindow: Window ? true : false,
  }
  return config
})
http.interceptors.response.use(
  (response) => {
    const res = response.data

    return res
  },
  (err) => Promise.reject(err)
)

const getUrlQuery = () => {
  const url = window.location.href
  const _url = url.split('?')
  if (_url.length >= 2) {
    return `?${_url[1]}`
  }
  return ''
}

// 手机校验
export const qyllbPhoneVerify = (data) => {
  return http({
    url: `/prod/order/v1/get/mobile/verify`,
    method: 'post',
    data,
  })
}
// 发送验证码
export const qyllbMobileProd = (data) => {
  return http({
    url: `/prod/order/v1/get/sms/mobileProd`,
    method: 'post',
    data,
  })
}
// 登陆
export const qyllbLogin = (data) => {
  return http({
    url: `/prod/order/v1/get/mobile/login`,
    method: 'post',
    data,
  })
}

export const qyllbPostOrder = (data) => {
  return http({
    url: `/prod/order/v1/package`,
    method: 'post',
    data,
  })
}


export const prodAuthApi = (data) => {
  return http({
    url: `prod/order/v1/package`,
    method: 'post',
    data,
  })
}





